export default __webpack_public_path__ + "postMock-1746189308299.html";